import _memoize from 'lodash/memoize';
import { HD, FULL_HD, safetyMargins } from '@bedrock-rdk/constants';
import { makeThemeColor, PRIMARY, TERTIARY } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';
import { SCREEN_WIDTH, SCREEN_HEIGHT } from '../../../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const WIDTH = {
  [HD]: 640,
  [FULL_HD]: 960,
};

export const AUDIO_MARGIN_BOTTOM = {
  [HD]: 8,
  [FULL_HD]: 16,
};

export const colors = {
  background: makeThemeColor(TERTIARY),
  backgroundOverlay: makeThemeColor(PRIMARY, 0.1),
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const contentViewportHeight = SCREEN_HEIGHT[screenSize] - safetyMargins.vertical[screenSize];
  const tracksPanelHeight = Math.round(contentViewportHeight / 2);

  return {
    x: SCREEN_WIDTH[screenSize],
    w: WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    color: colors.background[colorMode],
    BackgroundOverlay: {
      color: colors.backgroundOverlay[colorMode],
      w: WIDTH[screenSize],
      h: SCREEN_HEIGHT[screenSize],
    },
    Panels: {
      y: safetyMargins.vertical[screenSize],
      h: contentViewportHeight,
      w: WIDTH[screenSize],
      AudioTracks: {
        visible: false,
        w: WIDTH[screenSize],
        flexItem: {
          marginBottom: AUDIO_MARGIN_BOTTOM[screenSize],
          minHeight: tracksPanelHeight,
          grow: 1,
        },
      },
      SubtitleTracks: {
        visible: false,
        w: WIDTH[screenSize],
        flexItem: {
          minHeight: tracksPanelHeight,
          grow: 1,
        },
      },
      flex: {
        direction: 'column',
        justifyContent: 'flex-start',
      },
    },
  };
};

export const getFocusedStyle = _memoize(screenSize => ({
  smooth: {
    x: SCREEN_WIDTH[screenSize] - WIDTH[screenSize],
  },
}));

export const getUnFocusedStyle = _memoize(screenSize => ({
  smooth: {
    x: SCREEN_WIDTH[screenSize],
  },
}));
